import { useState } from 'react';
import { useContacts } from './useContacts';
import { useRefreshMessages } from './useRefreshMessages';

export function useRefreshAllMessages() {
  const [refreshing, setRefreshing] = useState(false);
  const { contacts } = useContacts();
  const { refreshMessages } = useRefreshMessages();

  const refreshAll = async () => {
    setRefreshing(true);
    try {
      const emailsToRefresh = contacts
        .map(contact => [contact.work_email, contact.personal_email])
        .flat()
        .filter((email): email is string => !!email);

      // Remove duplicates
      const uniqueEmails = [...new Set(emailsToRefresh)];

      // Refresh messages for each unique email
      for (const email of uniqueEmails) {
        await refreshMessages(email);
      }
    } catch (err) {
      console.error('Error refreshing all messages:', err);
      throw err;
    } finally {
      setRefreshing(false);
    }
  };

  return { refreshAll, refreshing };
}